import { z } from 'zod';

// Schemas (source of truth)
const translationSchema = z.record(z.string(), z.string());

export const tradeSchema = z.object({
	_id: z.string().optional(),
	tradeGroup: z.string(),
	tradeId: z.string(),
	backgroundColor: z.string(),
	sortIndex: z.number(),
	tradeTranslations: translationSchema.optional(), // TODO: check if optional is the solution
	tradeGroupTranslations: translationSchema.optional(), // TODO: check if optional is the solution
});

// Types (derived from schemas)
export type ITrade = z.infer<typeof tradeSchema>;
